import { fetchData, apiURL } from "./api_helper";

//  USER CRUD

//  CREATE
const createPartner = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/partners`;
    fetchData(endpointURL, "post", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ
const readPartner = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/partners/${data.id}`;
    fetchData(endpointURL, "get")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readPartners = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/partners`;
    fetchData(endpointURL, "get", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE
const updatePartner = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/partners/${data.id}`;
    fetchData(endpointURL, "PATCH", data.body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE
const deletePartner = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/partners/${data.id}`;
    fetchData(endpointURL, "delete")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  createPartner,
  readPartner,
  readPartners,
  updatePartner,
  deletePartner
};
